<template>
    <div class="list-page-wrapper" ref="list_page_wrapper">
        <div class="list-page-content" ref="list_page_content" :style="{ width: suggestWidth + 'px' }">
            <list-breadcrumb :breadcrumbs="breadcrumbs"></list-breadcrumb>
            <h2 class="list-page-title">
                {{ title }}
            </h2>
            <div class="list-page-header">
                <h2 class="list-page-count"><span class="span-list-page-count">{{ config.total }}</span>件</h2>
                <div class="list-page-actions">

                    <select name="pageMax" class="list-page-action-select" v-model="listCount" @change="changeCount()">
                        <option value="0">表示件数</option>
                        <option value="25">25件</option>
                        <option value="50">50件</option>
                        <option value="100">100件</option>
                    </select>
                </div>
                <div class="clearfix"></div>
            </div>

            <h2 class="sp-list-page-title">
                {{ title }}

                <select name="pageMax" class="sp-list-page-action-select" v-model="listCount" @change="changeCount()">
                    <option value="0">表示件数</option>
                    <option value="25">25件</option>
                    <option value="50">50件</option>
                    <option value="100">100件</option>
                </select>
            </h2>

            <div class="sp-list-page-header">
                <div class="sp-list-page-count">{{ config.total }}件</div>

                <div class="clearfix"></div>
            </div>
            <div class="user-items-container">
                <div class="user-items-container">
                <user-item v-for="item in content" :item="item" :key="item.id"></user-item>
                </div>

            </div>
        </div>

        <form action="/user" id="listForm">
            <input type="hidden" name="count" id="listFormCount" :value="config.count">
        </form>
    </div>
</template>

<script>
    export default {
        props: ['breadcrumbs', 'title', 'contents', 'configs'],
        data() {
            return {
                config: JSON.parse(this.configs),
                content: JSON.parse(this.contents),
                suggestWidth: null,
                csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                listCount: 0,
            }
        },
        mounted() {
            this.handleResize();
        },
        methods: {
            handleResize() {
                let window_width = window.innerWidth;

                if (this.$refs.list_page_wrapper == undefined) return;

                if (window_width >= 768) {
                    let wrapper_width = this.$refs.list_page_wrapper.clientWidth;
                    let iWidth = 210;
                    let suggestWidth = iWidth;
                    for (var i = 1; i < 100; i++) {
                        iWidth = 195 * i + 210;
                        if (iWidth >= wrapper_width) break;
                        suggestWidth = iWidth;
                    }
                    this.suggestWidth = suggestWidth;
                } else {
                    let wrapper_width = this.$refs.list_page_wrapper.clientWidth;
                    this.suggestWidth = wrapper_width;
                }
            },
            changeCount() {
                if (this.listCount > 0) {
                    $('#listFormCount').val(this.listCount);
                    $('#listForm').submit();
                }
            }
        },
        created() {
            window.addEventListener('resize', this.handleResize);
            this.handleResize();
            this.listCount = this.config.count
        },
        destroyed() {
            window.removeEventListener('resize', this.handleResize);
        },
    }
</script>

<style>
    .list-page-wrapper {
        width: 100%;
    }

    .list-page-content {
        margin-left: auto;
        margin-right: auto;
        overflow: hidden;
    }

    .list-page-content {
        padding-left: 15px;
        padding-right: 0;
    }

    @media (max-width: 768px) {
        .list-page-title {
            display: none;
        }

        .list-page-header {
            display: none;
        }

        .list-page-content {
            padding-left: 8px;
            padding-right: 8px;
        }
    }

    .list-page-title {
        font-size: 22px;
        font-weight: bold;
        margin-bottom: 60px;
    }

    .list-page-header {
        margin-bottom: 25px;
        overflow: hidden;
    }

    .list-page-count {
        font-size: 16px;
        float: left;
    }

    .span-list-page-count {
        font-size: 22px;
    }

    .list-page-actions {
        float: right;
        font-size: 17px;
    }

    .list-page-actions .list-page-action-link {
        margin-right: 20px;
    }

    .list-page-actions .list-page-action-link, .list-page-actions .list-page-action-link:visited {
        color: #000; text-decoration: none;
    }

    .list-page-actions .list-page-action-link:hover {
        color: #000; text-decoration: underline;
    }

    .list-page-actions .list-page-action-link.selected {
        text-decoration: underline;
    }

    .list-page-action-select {
        padding-right: 12px;
        outline: none;
        border: none;
        margin-right: 20px;
        cursor: pointer;
    }

    .sp-list-page-title {
        display: none;
    }

    .sp-list-page-action-select {
        display: none;
    }

    .sp-list-page-header {
        display: none;
    }

    @media (max-width: 768px) {
        .sp-list-page-title {
            display: block;
            margin-top: 30px;
            margin-bottom: 45px;
            font-size: 22px;
        }

        .sp-list-page-action-select {
            display: block;
            padding-right: 12px;
            outline: none;
            border: none;
            margin-right: 10px;
            float: right;
            font-size: 15px;
        }

        .sp-list-page-header {
            display: block;
            margin-bottom: 20px;
        }

        .sp-list-page-count {
            font-size: 15px;
            float: left;
        }

        .sp-list-page-actions {
            float: right;
            font-size: 15px;
        }

        .sp-list-page-actions .sp-list-page-action-link {
            margin-right: 10px;
        }

        .sp-list-page-actions .sp-list-page-action-link, .sp-list-page-actions .sp-list-page-action-link:visited {
            color: #000; text-decoration: none;
        }

        .sp-list-page-actions .sp-list-page-action-link:hover {
            color: #000; text-decoration: underline;
        }

        .sp-list-page-actions .sp-list-page-action-link.selected {
            text-decoration: underline;
        }
    }
</style>